import { render, staticRenderFns } from "./AddEditRelationDialog.vue?vue&type=template&id=7887498c&scoped=true"
import script from "./AddEditRelationDialog.vue?vue&type=script&lang=js"
export * from "./AddEditRelationDialog.vue?vue&type=script&lang=js"
import style0 from "./AddEditRelationDialog.vue?vue&type=style&index=0&id=7887498c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7887498c",
  null
  
)

export default component.exports